import React from "react";
import { MdFileDownload } from "react-icons/md";
import { CUPointContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import moment from "moment";
import { portalService } from "apiServices";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { toast } from "react-toastify";
import { RenderCommaMoney } from "utils/functions/FormatMoney";
import { RENDER_STATUS } from "utils/functions/transaction";
import { Buttons, Inputs, Tables, Displays } from "components";
import { AlertControl } from "components/Modals/Alert";
import { downloadCuPointTemplate } from "utils/functions/downloadTemplate";

class CUPointContainer extends React.Component {
  state = {};

  // ธงกันกดซ้ำแบบ synchronous เพราะ setState เป็น async
  // ถ้ากดรัวเร็วกว่า 1 รอบ render จะเช็คจาก state ไม่ทัน
  isApproving = false;

  componentDidMount() {
    scrollToTopPageFN();
  }

  handleChangeFile = (e) => {
    this.setState({
      fileCurrent: e,
    });
  };

  handleUpload = async () => {
    const { fileCurrent } = this.state;
    this.setState({
      isBgLoading: true,
    });
    if (!fileCurrent) {
      toast.error(`กรุณาอัพโหลดไฟล์`);
    } else {
      const bodyFormData = new FormData();
      bodyFormData.append("file", fileCurrent[0]);
      let res = await portalService.POST_IMPORT_POINT(bodyFormData);
      if (res && res.status === 200) {
        this.isApproving = false;
        this.setState({
          isSuccess: true,
          isApproved: false,
          approveFailCount: 0,
          isBgLoading: false,
          dataUploadPoint: res.data.uploadCuPoint,
          dataUserPoint: res.data.walletHistory,
          fileCurrent: false,
        });
        toast.success("ดราฟข้อมูลสำเร็จ");
      } else {
        this.setState({
          isSuccess: false,
          isBgLoading: false,
          data: res.data,
          fileCurrent: false,
        });
        toast.error(res.Message);
      }
    }
  };

  handleConfirm = async () => {
    const { dataUploadPoint, dataUserPoint, isApproved, isBgLoading } =
      this.state;
    if (isApproved || isBgLoading || this.isApproving) {
      return;
    }
    if (dataUploadPoint.length !== dataUserPoint.length) {
      toast.error("ข้อมูลในการอัพมีปัญหา ไม่ควรอนุมัติ");
    } else {
      AlertControl.show({
        title: "ยืนยันการอนุมัติ",
        description: "คุณต้องการจะอนุมัติใช่หรือไม่",
        btnLabel1: "ยกเลิก",
        btnLabel2: "ยืนยัน",
        onEvent2: async () => {
          // กันกรณีกดปุ่ม "ยืนยัน" ในโมดัลรัวก่อนโมดัลปิด ซึ่งจะทำให้ลูปอนุมัติ
          // รันซ้อนกันและยิง approve ด้วย id ชุดเดิมพร้อมกัน
          if (this.isApproving) {
            return;
          }
          this.isApproving = true;
          this.setState({
            isBgLoading: true,
          });
          let dataUploadPointTemp = dataUploadPoint;
          let dataUserPointTemp = dataUserPoint;
          let successCount = 0;
          let failCount = 0;
          const round = dataUploadPoint.length;
          for (let index = 0; index < round; index++) {
            let res;
            try {
              let params = {
                upload_point_id: dataUploadPoint[index]._id,
                wallet_history_id: dataUserPoint[index]._id,
                wallet_id: dataUserPoint[index].wallet_ref_id,
              };
              res = await portalService.POST_WALLET_APPROVE(params);
            } catch (error) {
              res = false;
            }
            if (res && res.status === 200) {
              successCount++;
              dataUploadPointTemp[index] = res.data.uploadCuPoint;
              dataUserPointTemp[index] = res.data.walletHistory;
            } else {
              failCount++;
              dataUploadPointTemp[index].status = "4";
              dataUserPointTemp[index].status = "4";
            }
            this.setState({
              dataUploadPoint: [...dataUploadPointTemp],
              dataUserPoint: [...dataUserPointTemp],
            });
          }
          this.setState({
            isBgLoading: false,
            isApproved: true,
            approveFailCount: failCount,
          });
          if (failCount === 0) {
            toast.success(`อนุมัติสำเร็จ ${successCount} รายการ`);
          } else if (successCount === 0) {
            toast.error(`อนุมัติไม่สำเร็จทั้งหมด ${failCount} รายการ`);
          } else {
            toast.warning(
              `อนุมัติสำเร็จ ${successCount} รายการ ไม่สำเร็จ ${failCount} รายการ`
            );
          }
        },
      });
    }
  };

  render() {
    const {
      isLoading,
      isBgLoading,
      data,
      fileCurrent,
      dataUploadPoint,
      dataUserPoint,
      isSuccess,
      isApproved,
      approveFailCount,
    } = this.state;
    return (
      <CUPointContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="input_upload_wrap">
          <div className="upload_block">
            <Inputs.UploadImage
              theme_upload_image
              value={fileCurrent}
              acceptType="csv"
              onChange={this.handleChangeFile}
            />
          </div>
          <div className="btn_action_filter">
            <Buttons.BgStandard label={"Upload"} onClick={this.handleUpload} />
          </div>
          <div className="btn_template">
            <Buttons.BgIconPrefix
              theme_outline
              label="Download template"
              icon={<MdFileDownload size={18} />}
              onClick={downloadCuPointTemplate}
            />
          </div>
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="311px" />
        ) : !isSuccess ? (
          data && (
            <>
              <div className="table_wrap">
                <div className="tabale_title">ตาราง Match สำเร็จ</div>
                <Tables.Standard
                  columns={columns}
                  data={data?.dataMatch || []}
                />
              </div>
              <div className="table_wrap">
                <div className="tabale_title">ตาราง Match ไม่สำเร็จ</div>
                <Tables.Standard
                  columns={columns}
                  data={data?.dataNotMatch || []}
                />
              </div>
            </>
          )
        ) : (
          dataUploadPoint && (
            <>
              <div className="table_wrap">
                <div className="tabale_title">
                  ธุรกรรม Upload point (
                  {dataUploadPoint ? dataUploadPoint.length : 0})
                </div>
                <Tables.Standard
                  columns={columnsUploadPoint}
                  data={dataUploadPoint || []}
                />
              </div>
              <div className="table_wrap">
                <div className="tabale_title">
                  ธุรกรรม User point ({dataUserPoint ? dataUserPoint.length : 0}
                  )
                </div>
                <Tables.Standard
                  columns={columnsUserPoint}
                  data={dataUserPoint || []}
                />
              </div>
              <div className="btn_approve">
                <Buttons.BgStandard
                  label={
                    !isApproved
                      ? "ยืนยันการอนุมัติ"
                      : approveFailCount > 0
                      ? "อนุมัติแล้ว (มีรายการไม่สำเร็จ)"
                      : "อนุมัติเรียบร้อยแล้ว"
                  }
                  disabled={isApproved}
                  onClick={this.handleConfirm}
                />
              </div>
            </>
          )
        )}
      </CUPointContainerStyled>
    );
  }
}

const columns = [
  {
    Header: <div style={{ textAlign: "left" }}>Upload date</div>,
    accessor: "Upload date",
    Cell: (props) => (
      <div>{moment(props.value, "YYYY-MM-DD").format("DD/MM/YYYY")}</div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Campaign code</div>,
    accessor: "Campaign code",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Login ID</div>,
    accessor: "Log in ID",
  },
  {
    Header: <div style={{ textAlign: "left" }}>CU code</div>,
    accessor: "CU code",
  },
  {
    Header: <div style={{ textAlign: "left" }}>SO Amount</div>,
    accessor: "SO Amount",
  },
  {
    Header: <div style={{ textAlign: "right" }}>Update Point</div>,
    accessor: "Update Point",
    Cell: (props) => (
      <div style={{ textAlign: "right" }}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
];

const columnsUploadPoint = [
  {
    Header: <div style={{ textAlign: "left" }}>Upload date</div>,
    accessor: "uploaded_at",
    Cell: (props) => (
      <div>{moment(props.value, "YYYY-MM-DD").format("DD/MM/YYYY")}</div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Customer id</div>,
    accessor: "customer_ref_id",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Customer user id</div>,
    accessor: "customer_user_id",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Customer cu id</div>,
    accessor: "customer_cu_id",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Campaign code</div>,
    accessor: "campaign_code",
  },
  {
    Header: <div style={{ textAlign: "left" }}>So amount</div>,
    accessor: "so_amount",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Point</div>,
    accessor: "point",
  },
  {
    Header: <div style={{ textAlign: "right" }}>Status</div>,
    accessor: "status",
    Cell: (props) => (
      <div style={{ textAlign: "right" }}>{RENDER_STATUS(props.value)}</div>
    ),
  },
];

const columnsUserPoint = [
  {
    Header: <div style={{ textAlign: "left" }}>Created date</div>,
    accessor: "created_at",
    Cell: (props) => (
      <div>{moment(props.value, "YYYY-MM-DD").format("DD/MM/YYYY")}</div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Customer id</div>,
    accessor: "customer_ref_id",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Customer user id</div>,
    accessor: "customer_user_id",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Customer cu id</div>,
    accessor: "customer_cu_id",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Campaign code</div>,
    accessor: "campaign_code",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Point</div>,
    accessor: "point",
  },
  // {
  //   Header: <div style={{ textAlign: "left" }}>Point in system</div>,
  //   accessor: "wallet_detail",
  //   Cell: (props) => props.value?.point,
  // },
  // {
  //   Header: <div style={{ textAlign: "left" }}>Total point</div>,
  //   accessor: "point_total",
  //   Cell: (props) =>
  //     props.row.original?.wallet_detail
  //       ? props.row.original?.point + props.row.original?.wallet_detail?.point
  //       : "ผิดพลาด",
  // },
  {
    Header: <div style={{ textAlign: "right" }}>Status</div>,
    accessor: "status",
    Cell: (props) => (
      <div style={{ textAlign: "right" }}>{RENDER_STATUS(props.value)}</div>
    ),
  },
];

export default withRouter(CUPointContainer);
